import { Box, Typography } from '@mui/material';

export default function NoAuthTemplates({ children }: Readonly<{ children: React.ReactNode }>) {
  return (
    <Box
      component="main"
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#EFF3F8',
      }}
    >
      <Box sx={{ position: 'relative' }}>
        {children}
        <Typography
          component="footer"
          align="center"
          color="#7F7F7F"
          fontSize={14}
          sx={{ position: 'absolute', bottom: -140, left: 0, right: 0 }}
        >
          Copyright ©m2Cloud Inc. All Rights Reserved.
        </Typography>
      </Box>
    </Box>
  );
}
